import { faker } from '@faker-js/faker'

import { TreatmentCategory } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getTreatmentCategory = asBuilder((): TreatmentCategory => {
  return {
    id: faker.number.int(),
    name: faker.string.uuid(),
  }
})
